import * as Toastr from 'toastr';

const toastr = Toastr
toastr.options.timeOut = 1800;

export default toastr